export default __webpack_public_path__ + "acbd6ecc97c80340e9bf00ea80063234.woff";